import { environment } from "../environment";
import { AsyncResult } from "../models/common/async-result";
import { LiteraryGenre } from "../models/literaryGenre";
import { genresTranslation } from "../utils/genres";
import { capitalize } from "../utils/string";
import api from "./api";

const getTranslate = (genresResult: LiteraryGenre[]) => {
  return genresResult.map(value => {
    return { ...value, content: capitalize(genresTranslation[value.content]), label: capitalize(genresTranslation[value.content]) }
  }).sort((a, b) => {
    if (a.content < b.content) {
      return -1;
    }
    if (a.content > b.content) {
      return 1;
    }
    return 0;
  });
}

export async function getUserGenres(userId: number): Promise<LiteraryGenre[]> {
  const baseUrl = environment.api.genres.getUserGenres

  const url = baseUrl
    .replace('{userId}', String(userId));

  const response = await api.get(url)
    .then(res => getTranslate(res.data.success))
    .catch(res => []);

  return response
}

export async function getBooksGenres(bookId: number): Promise<LiteraryGenre[]> {
  const baseUrl = environment.api.genres.getBookGenres

  const url = baseUrl
    .replace('{bookId}', String(bookId));

  const response = await api.get(url)
    .then(res => getTranslate(res.data.success))
    .catch(res => []);

  return response
}

export async function getAllGenres(): Promise<LiteraryGenre[]> {
  const baseUrl = environment.api.genres.getAll

  const response = await api.get(baseUrl)
    .then(res => getTranslate(res.data.success))
    .catch(res => []);

  return response
}

export async function getClubGenres(clubId: number): Promise<LiteraryGenre[]> {
  const baseUrl = environment.api.genres.getClubGenres

  const url = baseUrl
    .replace('{clubId}', String(clubId));

  const response = await api.get(url)
    .then(res => getTranslate(res.data.success))
    .catch(res => []);

  return response
}

export async function createUserGenres(userId: number, genres: number[]): Promise<AsyncResult<number>> {
  const baseUrl = environment.api.genres.createUser

  const url = baseUrl
    .replace('{userId}', String(userId))

  const response = await api.post(url, { genres })
    .then(res => res.data.success);

  return response
}

export async function createBookGenres(bookId: number, genres: number[]): Promise<AsyncResult<number>> {
  const baseUrl = environment.api.genres.createBook

  const url = baseUrl
    .replace('{bookId}', String(bookId))

  const response = await api.post(url, { genres })
    .then(res => res.data.success);

  return response
}

export async function createClubGenres(clubId: number, genres: number[]): Promise<AsyncResult<number>> {
  const baseUrl = environment.api.genres.createClub

  const url = baseUrl
    .replace('{clubId}', String(clubId))

  const response = await api.post(url, { genres })
    .then(res => res.data.success);

  return response
}

export async function editClubGenres(clubId: number, genres: number[]): Promise<AsyncResult<number>> {
  const baseUrl = environment.api.genres.createClub

  const url = baseUrl
    .replace('{clubId}', String(clubId))

  const response = await api.put(url, { genres })
    .then(res => res.data.success);

  return response
}

export async function editUsersGenres(userId: number, genres: number[]): Promise<AsyncResult<number>> {
  const baseUrl = environment.api.genres.createUser

  const url = baseUrl
    .replace('{userId}', String(userId))

  const response = await api.put(url, { genres })
    .then(res => res.data.success);

  return response
}